import { Button } from 'primereact/button';
import classes from './loginFailureScreen.module.scss';
import useLoginFailureScreenLogic from './useLoginFailureScreenLogic';

const LoginFailureScreen = () => {
  const { loginFailureReason, handleLogin, handleNavigateToHome, isLoginRedirectLinkLoading } =
    useLoginFailureScreenLogic();
  return (
    <div className={classes.loginFailureScreenContainer}>
      <div className={classes.loginFailedHeading}>Login Failed</div>
      <div className={classes.loginFailureReason}>{loginFailureReason}</div>
      <div className={classes.buttonDivWrapper}>
        <Button
          label="Go to Home"
          className={classes.goToHomeButton}
          onClick={handleNavigateToHome}
        />
        <Button
          label="Retry Login"
          className={classes.retryLoginButton}
          onClick={handleLogin}
          loading={isLoginRedirectLinkLoading}
        />
      </div>
    </div>
  );
};

export default LoginFailureScreen;
